import * as React from "react";
import { useEffect, useState, ChangeEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  Button,
  Checkbox,
  Alert,
  CircularProgress
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useForm, Controller, FieldValues } from "react-hook-form";
import { ServiceName } from "../../../constants";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../../config/config";
import { ToastMessage } from "../../util/ToastMessage";
import { array } from "yargs";
import { setuid } from "process";

import { FundConfigModel } from "../../util/All_interfaces";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";
import { UserContext, updateUserContext } from "../../../redux/slices/userContextSlice";
import { getProfile } from "../../../services/userContext";
import { useDispatch } from "react-redux";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;



export const FundConfigurationNewForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const userId = params.fundID;

  const [postFormdata, setPostFormData] = useState<FundConfigModel | any>({
    fundID: '',
    fundName: '',
    investmentType: '',
    appraisalSchedule: '',
    isFiduciaryApprovalRequired: false,
    delayPosting: '',
    scheduleDayAppraisal: '',
    scheduleDelayCount: 0,
    workflowtemplate: '',
    workflowVersion: '',
    region: '',
    isBlackOutRequired: false,
    isValuationTypeRequired: false,
    percentageChange: '',
    id: 0,
    createdBy: '',
    created: '',
    lastModifiedBy: '',
    lastModified: ''
  });

  const [postFormdataError, setPostFormdataError] = useState<any>({
    fundName: false,
    investmentType: false,
    appraisalSchedule: false,
    delayPosting: false,
    scheduleDayAppraisal: false,
    workflowtemplate: false,
    region: false,
    percentageChange: false
  });

  const [regionList, setRegionList] = useState([{ title: "US", id: 1 },
  { title: "EMEA", id: 2 }, { title: "APAC", id: 3 }]);

  const [status, setStatus] = useState<string>("false");
  const [valuationType, setValuationType] = useState<string>("false");
  const [loading, setLoading] = useState(false);

  const [funds, setFunds] = useState<Array<{ id: number, fundID: string, fundName: string, region: string, createdBy: string }>>([]);
  const [workflow, setWorkflow] = useState<Array<{ id: number, name: string, version: string }>>([]);

  const [postDataMessage, setPostDataMessage] = useState<{ code: number, message: string, isError: boolean }>({ code: 0, message: "", isError: false });

  const currentUserData: CurrentUser = useAppSelector((state) => state.currentUser.data);
  const userContext: UserContext = useAppSelector((state) => state.UserContext.data);

  const handleStatusChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setPostFormData({ ...postFormdata, isBlackOutRequired: (value == "true") });
    setStatus(value);
  };

  const handleValuationTypeChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setPostFormData({ ...postFormdata, isValuationTypeRequired: (value == "true") });
    setValuationType(value);
  };

  const fetchData = async () => {
    await getApiCall(`${TaskmgmtServiceURL}/Funds/getall`,
      ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
        setFunds(data.result);
        setLoading(false);
      });

    await getApiCall(`${TaskmgmtServiceURL}/WorkflowTemplates/GetAll`,
      ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
        setWorkflow(data.result);
        setLoading(false);
      });
  }

  // useEffect(() => {
  //   setLoading(true);
  //   fetchData();
  // }, []);

  const postData = async () => {

    await postApiCall(`${TaskmgmtServiceURL}/FundConfigurations/Save`, postFormdata, ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
      setLoading(false);
      setPostDataMessage({ code: 1, message: postFormdata.fundID + " Configuration record is successfully submitted", isError: false });

      setTimeout(() => {
        navigate(`/fundconfig/list/`)
      }
        , 3000);

    }).catch((e: any) => {
      var msg = '';
      if(e.response.data.responseException.exceptionMessage.includes( "Configuration record already exist")){
        msg = postFormdata.fundID + " Configuration record already exist";
      }
      setPostDataMessage({ code: e.response.status, message: msg, isError: true });
      setLoading(false);
    });
  }

  const investmentType = ["Equity", "Debt Asset", "Debt Liability", "Mortgage"];
  const scheduleList = ["Quarterly", "Semi-Annually", "Annually", "Ad-Hoc"];
  const scheduleDay = ["1st Day of Month", "Last Day of Month"];

  const { control, handleSubmit } = useForm({});

  const handleRegionChangeAndDateTime = (value: any) => {

    let today = new Date();
    let date = today.getDate() + "-" + today.getMonth() + 1 + "-" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var selectedRegions = '';

    if (value.length == 0) {
      selectedRegions = '';
    } else {
      var tempRegions: any[] = [];
      value.forEach((element: { title: any; }) => {
        tempRegions.push(element.title);
      });
      var sortedTempRegions = tempRegions.sort().reverse();

      sortedTempRegions.forEach((element: any) => {
        if (selectedRegions == '') {
          selectedRegions = element;
        } else {
          selectedRegions = selectedRegions + ";" + element;
        }
      });
    }

    setPostFormData({
      ...postFormdata, region: selectedRegions, createdBy: currentUserData.email,
      created: date, lastModified: date, lastModifiedBy: currentUserData.email
    });
  }

  const submitForm = () => {
    setLoading(true);

    if (postFormdata.fundName.length === 0 ||
      postFormdata.investmentType.length === 0 ||
      postFormdata.appraisalSchedule.length === 0 ||
      postFormdata.delayPosting.length === 0 ||
      postFormdata.scheduleDayAppraisal.length === 0 ||
      postFormdata.workflowtemplate.length === 0 ||
      postFormdata.region.length === 0 ||
      postFormdata.percentageChange.length === 0) {
      setLoading(false);
      setPostDataMessage({ code: 0, message: "Please correct the validation errors!", isError: true });

      setTimeout(() => {
        setPostDataMessage({ code: 0, message: "", isError: false });
      }
        , 1500);

    } else {
      setPostDataMessage({ code: 0, message: "", isError: false });
      postData();
    }

  }

  useEffect(() => {
    if (Object.keys(userContext).length == 0) {
      getProfile(true).then((data: any) => {
        dispatch(updateUserContext(data));
      });
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    if (Object.keys(userContext).length != 0) {
      fetchData();

      var regionContext = userContext.region;
      if (regionContext != '') {
        if (regionContext == 'US;EMEA') {
          setRegionList(
            [{ title: "US", id: 1 },
            { title: "EMEA", id: 2 }])
        }
        else if (regionContext == 'US;APAC') {
          setRegionList(
            [{ title: "US", id: 1 },
            { title: "APAC", id: 2 }])
        }
        else if (regionContext == 'EMEA;APAC') {
          setRegionList(
            [{ title: "EMEA", id: 1 },
            { title: "APAC", id: 2 }])
        }
      }

    }

  }, [userContext]);

  return (
    <div className="form-wrap">
      {postDataMessage.isError ?
        <ToastMessage message={postDataMessage.message} severity="error" />
        : null}
      {postDataMessage.code == 1 ?
        <ToastMessage message={postDataMessage.message} severity="success" />
        : null}
      <Box sx={{ width: "100%", typography: "body1" }}>
        {loading ? (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        ) : null}
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <Controller
              name="fundName"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="fund-id"
                  options={funds}
                  getOptionLabel={(option) => option.fundName}

                  onChange={(event: any, value: any) => {
                    if (value != null) {
                      setPostFormData({ ...postFormdata, fundName: value.fundName, fundID: value.fundID });
                      setPostFormdataError({ ...postFormdataError, fundName: false });
                    } else {
                      setPostFormData({ ...postFormdata, fundName: '', fundID: '' });
                      setPostFormdataError({ ...postFormdataError, fundName: true });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fund"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.fundName}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="investmentType"
              control={control}
              render={({ field }) => (
                <Autocomplete

                  id="fund-id"
                  options={investmentType}
                  value={postFormdata?.investmentType}
                  onChange={(event: any, value: any) => {
                    if (value == null) {
                      setPostFormData({ ...postFormdata, investmentType: '' });
                      setPostFormdataError({ ...postFormdataError, investmentType: true });
                    } else {
                      setPostFormData({ ...postFormdata, investmentType: value });
                      setPostFormdataError({ ...postFormdataError, investmentType: false || postFormdataError.investmentType.length == 0 });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Investment Type"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.investmentType}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="Schedule"
              control={control}
              render={({ field }) => (
                <Autocomplete

                  id="fund-id"
                  options={scheduleList}
                  value={postFormdata?.appraisalSchedule}
                  onChange={(event: any, value: any) => {
                    if (value == null) {
                      setPostFormData({ ...postFormdata, appraisalSchedule: '' });
                      setPostFormdataError({ ...postFormdataError, appraisalSchedule: true })
                    } else {
                      setPostFormData({ ...postFormdata, appraisalSchedule: value });
                      setPostFormdataError({ ...postFormdataError, appraisalSchedule: false })
                    }

                  }}
                  // sx={{ width: 400 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Schedule"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.appraisalSchedule}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="PercentageChange"
              control={control}
              render={({ field }) => (
                <TextField
                  id="outlined-number"
                  label="Percentage Change"
                  type="number"
                  size="small"
                  onChange={(event: any) => {
                    setPostFormData({ ...postFormdata, percentageChange: event.target.value });
                    setPostFormdataError({ ...postFormdataError, percentageChange: event.target.value.length == 0 });
                  }}
                  required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  error={postFormdataError.percentageChange}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <FormControl

              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">
                Is Blackout Period Required
              </FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={status}
                onChange={handleStatusChange}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6}>
            <FormControl

              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">
                Is Valuation Type Required
              </FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={valuationType}
                onChange={handleValuationTypeChange}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="DelayPosting"
              control={control}
              render={({ field }) => (
                <TextField

                  id="outlined-number"
                  label="Delay Posting"
                  type="number"
                  size="small"
                  onChange={(event: any) => {
                    setPostFormData({ ...postFormdata, delayPosting: event.target.value });
                    setPostFormdataError({ ...postFormdataError, delayPosting: event.target.value.length == 0 });
                  }}
                  required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  error={postFormdataError.delayPosting}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="ScheduleDay"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="fund-id"
                  options={scheduleDay}
                  onChange={(event: any, value: any) => {
                    if (value == null) {
                      setPostFormData({ ...postFormdata, scheduleDayAppraisal: '' });
                      setPostFormdataError({ ...postFormdataError, scheduleDayAppraisal: true });
                    } else {
                      setPostFormData({ ...postFormdata, scheduleDayAppraisal: value });
                      setPostFormdataError({ ...postFormdataError, scheduleDayAppraisal: false || value.length == 0 });
                    }
                  }}
                  value={postFormdata.scheduleDayAppraisal}
                  // sx={{ width: 400 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Schedule Day"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.scheduleDayAppraisal}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="Workflow Template"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="fund-id"
                  options={workflow}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => {

                    if (value == null) {
                      setPostFormData({ ...postFormdata, workflowtemplate: '', workflowVersion: '' });
                      setPostFormdataError({ ...postFormdataError, workflowtemplate: true });
                    } else {
                      setPostFormData({ ...postFormdata, workflowtemplate: value?.name, workflowVersion: value?.version });
                      setPostFormdataError({ ...postFormdataError, workflowtemplate: false || value.name.length == 0 });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Workflow Template"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.workflowtemplate}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <TextField
              variant="outlined"
              size="small"
              inputProps={{
                readOnly: true
              }}
              fullWidth
              label="Workflow Version"
              value={postFormdata.workflowVersion}
              className="Autopopulatefield"
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="Region"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  options={regionList}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.title}
                  onChange={(event, value) => {
                    handleRegionChangeAndDateTime(value);
                    setPostFormdataError({ ...postFormdataError, region: false || value.length == 0 });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.title}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.region}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Button sx={{textTransform:"none"}} variant="contained" size="medium" color="success" onClick={() => {
              submitForm();
              setPostFormdataError({
                ...postFormdataError,
                fundName: postFormdata.fundName.length === 0,
                investmentType: postFormdata.investmentType.length === 0,
                appraisalSchedule: postFormdata.appraisalSchedule.length === 0,
                delayPosting: postFormdata.delayPosting.length === 0,
                scheduleDayAppraisal: postFormdata.scheduleDayAppraisal.length === 0,
                workflowtemplate: postFormdata.workflowtemplate.length === 0,
                region: postFormdata.region.length === 0,
                percentageChange: postFormdata.percentageChange.length === 0
              });
            }}>
              Submit
            </Button>
            <Button 
              variant="outlined"
              size="medium"
              color="error"
              sx={{ ml: 2 }}
              onClick={() => navigate("/fundconfig/list")}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
